module.exports = __webpack_public_path__ + "img/ics_o_briefcase.7c2c51d6.svg";